import { IconButton, InputAdornment, TextField } from '@mui/material';
import useDebounceSearch from 'hooks/useDebounceSearch';
import useSearch from 'hooks/useSearch';
import { memo, useEffect } from 'react';
import { NumericFormat } from 'react-number-format';

const NumberRangeFilter = ({
  queries = { from: 'from', till: 'till' },
  labels = { from: 'dan', till: 'till' },
  className,
}) => {
  const query = useSearch();
  const [homeSquareFrom, setHomeSquareFrom] = useDebounceSearch(
    queries.from,
    '',
    300
  );
  const [homeSquareTill, setHomeSquareTill] = useDebounceSearch(
    queries.till,
    '',
    300
  );

  useEffect(() => {
    if (!query.get(queries.from)) setHomeSquareFrom('');
    if (!query.get(queries.till)) setHomeSquareTill('');
  }, [query.get(queries.from), query.get(queries.till)]);

  return (
    <div className='flex flex-row'>
      <NumericFormat
        className={className}
        id={queries.from}
        name={queries.from}
        label={<span>{labels.from}</span>}
        value={homeSquareFrom}
        onInput={(event) => setHomeSquareFrom(event.target?.value)}
        color='formColor'
        variant='outlined'
        fullWidth
        customInput={TextField}
        InputProps={{
          endAdornment: (
            <InputAdornment position='end' className='custom-endAdornment'>
              {homeSquareFrom && (
                <IconButton
                  onClick={() => setHomeSquareFrom('')}
                  variant='onlyIcon'
                >
                  <i className='bi bi-x end-adornment-close-button' />
                </IconButton>
              )}
            </InputAdornment>
          ),
          sx: {
            borderTopRightRadius: '0 !important',
            borderBottomRightRadius: '0 !important',
          },
        }}
        sx={{
          marginTop: '0.25rem',
          marginBottom: '0.25rem',
        }}
        allowNegative={false}
        decimalScale={0}
      />

      <NumericFormat
        className={className}
        id={queries.till}
        name={queries.till}
        label={<span>{labels.till}</span>}
        value={homeSquareTill}
        onInput={(event) => setHomeSquareTill(event.target?.value)}
        color='formColor'
        variant='outlined'
        fullWidth
        customInput={TextField}
        InputProps={{
          endAdornment: (
            <InputAdornment position='end' className='custom-endAdornment'>
              {homeSquareTill && (
                <IconButton
                  onClick={() => setHomeSquareTill('')}
                  variant='onlyIcon'
                >
                  <i className='bi bi-x end-adornment-close-button' />
                </IconButton>
              )}
            </InputAdornment>
          ),
          sx: {
            borderTopLeftRadius: '0 !important',
            borderBottomLeftRadius: '0 !important',
          },
        }}
        sx={{
          marginTop: '0.25rem',
          marginBottom: '0.25rem',
        }}
        allowNegative={false}
        decimalScale={0}
      />
    </div>
  );
};

export default memo(NumberRangeFilter);
